
define(
    'viewmodels/secured/help/guided/usingThisGuide',[
        "viewmodels/ViewModel",
        "plugins/router",
        "helper/textParser",
        "services/session",
        "i19n!i19n/strings",
    ],
    function (ViewModel, router, textParser, session, i19n) {

        var vm = new ViewModel({
            i19n: i19n,
            id: '0',
            descriptions: ko.observableArray([]),
            todos: ko.observableArray([]),
            readonly: ko.observable(true).extend({ notify: 'always' }),
            tip: ko.observable('')
        });

        vm.activate = function () {
            //text | href | target
            
            if (vm.descriptions().length == 0) {
                vm.descriptions.push("<b>Welcome to fileplan!</b> ");
                vm.descriptions.push("As the Instance Administrator, you'll find that getting started in fileplan is simple. Use this setup guide to learn more about the key steps needed to configure fileplan just for you. ");
                vm.descriptions.push("You can close and return to this guide at any time from the Help menu. ");
            }
            if (vm.todos().length == 0) {
                vm.todos.push({ icon: 'fa-video-camera', isDone: false, html: i19n.to.thisiconindicateslinksto1 });
                vm.todos.push({ icon: 'fa-book', isDone: session.settingsGuided().Topic1b, html: i19n.to.thisiconindicateslinksto2 });
                vm.todos.push({ icon: 'fa-hand-pointer-o', isDone: session.settingsGuided().Topic1c, html: i19n.to.thisiconindicateslinksto3 });
            }

            vm.tip(textParser.toHtml(i19n.to.tiplookatthisiconfortipandtricks));
        };
        vm.attached = function () {
            vm.readonly.subscribe(function (value) {
                if (!value)
                    vm.readonly(true);
            });
        };

        return vm;
    }
);
